class AppSettings {
  constructor (sdk) {
    sdk.get('/appsettings', {}, response => {
      this.config = response
    }, '')
  }

  get (configName) {
    return this.config[configName]
  }
}

export default AppSettings



// WEBPACK FOOTER //
// ./src/modules/gateway-sdk/app-settings.js